import { SUBJECT_MAX, countChars } from './draftCaps';

/** Go keeps {creator_name} to a name of at most this many characters. */
const CREATOR_NAME_MAX = 40;

export interface SubjectEstimateContext {
  campaignName?: string;
  brandName?: string;
  /** Every creator name in the campaign's outreach list; the longest one is used. */
  creatorNames: string[];
  year: number;
}

const longest = (values: string[]): string => values.reduce((best, value) => (countChars(value) > countChars(best) ? value : best), '');

const clip = (name: string): string => Array.from(name).slice(0, CREATOR_NAME_MAX).join('');

/** The subject as it would read for the creator with the longest name. A tag whose value isn't known here stays as typed. */
export function fillSubjectForEstimate(subject: string, ctx: SubjectEstimateContext): string {
  const name = clip(longest(ctx.creatorNames.map((n) => n.trim()).filter(Boolean)));
  const firstName = clip(longest(ctx.creatorNames.map((n) => n.trim().split(/\s+/)[0] ?? '').filter(Boolean)));
  const values: Record<string, string | undefined> = {
    brand: ctx.brandName?.trim(),
    campaign: ctx.campaignName?.trim(),
    creator_name: name,
    first_name: firstName,
    year: String(ctx.year),
  };
  return subject.replace(/\{(\w+)\}/g, (tag, key: string) => (values[key] ? values[key] : tag));
}

/** The estimated length when it passes the subject limit, else null. */
export function subjectEstimateOverCap(subject: string, ctx: SubjectEstimateContext): number | null {
  const estimate = countChars(fillSubjectForEstimate(subject, ctx).trim());
  return estimate > SUBJECT_MAX ? estimate : null;
}

export function subjectCouldBeLongWarning(estimate: number): string {
  return `This subject could run to about ${estimate} characters once filled in. Over ${SUBJECT_MAX} is blocked at the Drafts step, so shorten it or the campaign name.`;
}
